import { Collections } from '../../constants';
import { isClassified, isObituary } from '../../types/ad';
import { SerializedModel } from '../types';
import { ClassifiedModel } from './classifiedModel';
import { ObituaryModel } from './obituaryModel';

export type SerializedAdModel = SerializedModel<
  typeof Collections.obituaries | typeof Collections.classifieds
>;

export type AdModel = ClassifiedModel | ObituaryModel;

export const isObituaryModel = (adModel: AdModel): adModel is ObituaryModel =>
  isObituary(adModel.modelData);

export const isClassifiedModel = (
  adModel: AdModel
): adModel is ClassifiedModel => isClassified(adModel.modelData);
